// Admin and Agent are separate portals sharing this codebase. In practice
// they're served from different hostnames (see getActorTypeFromHost), so
// the browser's same-origin policy already isolates their localStorage in
// production. These keys are still namespaced per role as defense-in-depth
// for local/dev setups (or any future same-origin deployment) where that
// isolation wouldn't otherwise exist.
export const ADMIN_STORAGE_KEYS = {
  userInfo: "admin-user-info",
} as const;

export const AGENT_STORAGE_KEYS = {
  userInfo: "agent-user-info",
} as const;

export const CHAT_NOTIFICATIONS_ASKED_KEY = "chat-notifications-asked";
